import type { ApiAcceptedLanguage, NabanApi } from '@izimi/api';

import type { AuthenticationMethod } from './store';

export const getAuthenticationMethodsItems = ({
  data,
}: {
  data?: Awaited<ReturnType<NabanApi['getNabanAuthenticationModes']>>;
}): Array<AuthenticationMethod | Array<AuthenticationMethod>> => {
  if (data == null) {
    return [];
  }

  return [
    data.citizenAuthentication && {
      type: 'personal',
      token: data.citizenAuthentication.authenticationModeToken,
    },
    ...(data.companyAuthentications && !data.companyServiceDown
      ? data.companyAuthentications.map<Array<AuthenticationMethod>>((company) => [
          {
            type: 'company',
            id: company.enterpriseNumber,
            name: company.enterpriseName,
            token: company.authenticationModeToken,
          },
          {
            type: 'companyAndSisterCompanies',
            id: company.enterpriseNumber,
            name: company.enterpriseName,
            token: company.authenticationModeTokenWithInheritedCompanies,
          },
        ])
      : []),
    ...(data.heirAuthentications && !data.heirServiceDown
      ? data.heirAuthentications.map<AuthenticationMethod>((heir) => ({
          type: 'heir',
          token: heir.authenticationModeToken,
          firstName: heir.firstNames,
          lastName: heir.lastName,
        }))
      : []),
  ].filter((item): item is AuthenticationMethod | Array<AuthenticationMethod> => Boolean(item));
};

export const getNotaryWebsiteUrl = ({
  fallbackLanguage,
}: {
  fallbackLanguage: ApiAcceptedLanguage;
}) => {
  const { hostname } = window.location;

  const urls = {
    fr: 'https://www.notaire.be',
    nl: 'https://www.notaris.be',
  };

  if (hostname.includes('notaire')) {
    return urls.fr;
  }

  if (hostname.includes('notaris')) {
    return urls.nl;
  }

  if (fallbackLanguage === 'nl') {
    return urls.nl;
  }

  return urls.fr;
};

export const getEcbEnterpriseUrl = ({
  bceEnterpriseNumber,
  lang,
}: {
  bceEnterpriseNumber: string;
  lang: ApiAcceptedLanguage;
}) =>
  `https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html?lang=${lang}&nummer=${bceEnterpriseNumber}`;
